module.exports = __webpack_public_path__ + "img/arrow-r.08ba52df.svg";